import { render, staticRenderFns } from "./FinreestrPage.vue?vue&type=template&id=13b4db6e&scoped=true"
import script from "./FinreestrPage.vue?vue&type=script&lang=js"
export * from "./FinreestrPage.vue?vue&type=script&lang=js"
import style0 from "./FinreestrPage.vue?vue&type=style&index=0&id=13b4db6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4db6e",
  null
  
)

export default component.exports